import { useStore } from "..";
export const useUpload = () => useStore(({ upload }) => upload);
